var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopContributor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 119,
    viewBox: "0 0 154 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.735 25.5391L105.172 29.126V41.1279L143.382 38.3055C145.89 38.1222 147.954 36.7555 149.106 34.5195L153.735 25.5391Z",
    fill: "url(#paint0_linear_308_7963)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.172 40.0149L143.984 37.1453C146.493 36.962 148.556 35.5953 149.708 33.3594L149.106 34.5219C147.954 36.7578 145.89 38.1245 143.382 38.3078L105.172 41.1302V40.0096V40.0149Z",
    fill: "url(#paint1_linear_308_7963)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.382 38.3086L105.172 41.131V53.1329L133.035 51.075C135.543 50.8917 137.606 49.525 138.758 47.2891L143.387 38.3086H143.382Z",
    fill: "url(#paint2_linear_308_7963)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.175 52.016L133.635 49.9109C136.143 49.7277 138.207 48.361 139.359 46.125L138.756 47.2875C137.604 49.5234 135.541 50.8902 133.033 51.0734L105.17 53.1313V52.0107L105.175 52.016Z",
    fill: "url(#paint3_linear_308_7963)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.033 51.0742L105.17 53.1321V65.134L122.681 63.8406C125.189 63.6574 127.252 62.2907 128.404 60.0547L133.033 51.0742Z",
    fill: "url(#paint4_linear_308_7963)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.175 64.0132L123.283 62.6727C125.791 62.4894 127.854 61.1227 129.006 58.8867L128.404 60.0492C127.252 62.2852 125.189 63.6519 122.681 63.8351L105.17 65.1285V64.0079L105.175 64.0132Z",
    fill: "url(#paint5_linear_308_7963)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.712891 25.5391L49.2756 29.126V41.1279L11.0653 38.3055C8.55707 38.1222 6.49391 36.7555 5.3419 34.5195L0.712891 25.5391Z",
    fill: "url(#paint6_linear_308_7963)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.278 40.0149L10.4656 37.1453C7.95736 36.962 5.8942 35.5953 4.74219 33.3594L5.34438 34.5219C6.49639 36.7578 8.55955 38.1245 11.0678 38.3078L49.278 41.1302V40.0096V40.0149Z",
    fill: "url(#paint7_linear_308_7963)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0677 38.3086L49.278 41.131V53.1329L21.4149 51.075C18.9067 50.8917 16.8435 49.525 15.6915 47.2891L11.0625 38.3086H11.0677Z",
    fill: "url(#paint8_linear_308_7963)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2772 52.016L20.8172 49.9109C18.3089 49.7277 16.2458 48.361 15.0938 46.125L15.6959 47.2875C16.848 49.5234 18.9111 50.8902 21.4194 51.0734L49.2824 53.1313V52.0107L49.2772 52.016Z",
    fill: "url(#paint9_linear_308_7963)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4141 51.0742L49.2771 53.1321V65.134L31.7665 63.8406C29.2582 63.6574 27.1951 62.2907 26.0431 60.0547L21.4141 51.0742Z",
    fill: "url(#paint10_linear_308_7963)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2763 64.0132L31.1687 62.6727C28.6605 62.4894 26.5973 61.1227 25.4453 58.8867L26.0475 60.0492C27.1995 62.2852 29.2627 63.6519 31.7709 63.8351L49.2816 65.1285V64.0079L49.2763 64.0132Z",
    fill: "url(#paint11_linear_308_7963)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8727 95.5483C68.9028 92.8097 60.7706 89.5003 54.6074 83.5621C45.1504 74.4508 42.8516 61.1502 42.8516 48.5671V21.8037L43.5428 21.5366C54.2199 17.4051 65.7243 14.5198 77.1031 13.2683L77.2235 13.2578L77.3439 13.2683C88.7227 14.525 100.227 17.4051 110.904 21.5366L111.595 21.8037V48.5671C111.595 61.1555 109.297 74.4508 99.8397 83.5621C93.6764 89.5003 85.5494 92.8097 77.5743 95.5483L77.2235 95.6688L76.8727 95.5483Z",
    fill: "url(#paint12_linear_308_7963)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3639 18.7832C50.5648 13.6567 64.1481 10.1064 77.2235 8.73446V3.13672C61.7655 4.6867 45.8834 9.20574 32.7871 15.1386L38.3587 18.7884L38.3639 18.7832Z",
    fill: "url(#paint13_linear_308_7963)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2228 8.73438C64.1475 10.1063 50.5589 13.6566 38.3633 18.7831L43.9348 22.5428C54.5386 18.4375 66.0745 15.5627 77.2228 14.3374V8.73438Z",
    fill: "url(#paint14_linear_308_7963)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3626 48.5674V18.7826L32.791 15.1328V48.5674C32.791 90.7993 57.5436 99.7431 77.2274 106.289V100.413C67.9484 97.2872 58.6799 93.7212 51.4956 86.7986C41.1012 76.7813 38.3678 62.4859 38.3678 48.5674H38.3626Z",
    fill: "url(#paint15_linear_308_7963)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3646 18.7812V48.5661C38.3646 62.4845 41.098 76.78 51.4923 86.7973C58.6715 93.7198 67.9452 97.2859 77.2242 100.412V94.5262C69.3695 91.8242 61.3735 88.5777 55.3568 82.7862C46.1407 73.9052 43.9309 60.856 43.9309 48.5661V22.541L38.3594 18.7812H38.3646Z",
    fill: "url(#paint16_linear_308_7963)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.088 18.7832C103.887 13.6567 90.3039 10.1064 77.2285 8.73446V3.13672C92.6865 4.6867 108.569 9.20574 121.665 15.1386L116.093 18.7884L116.088 18.7832Z",
    fill: "url(#paint17_linear_308_7963)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2227 8.73438C90.298 10.1063 103.887 13.6566 116.082 18.7831L110.511 22.5428C99.9069 18.4375 88.3658 15.5627 77.2227 14.3374V8.73438Z",
    fill: "url(#paint18_linear_308_7963)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.087 48.5674V18.7826L121.659 15.1328V48.5674C121.659 90.7993 96.9064 99.7431 77.2227 106.289V100.413C86.5016 97.2872 95.7701 93.7212 102.954 86.7986C113.349 76.7813 116.082 62.4859 116.082 48.5674H116.087Z",
    fill: "url(#paint19_linear_308_7963)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.088 18.7812V48.5661C116.088 62.4845 113.355 76.78 102.96 86.7973C95.776 93.7198 86.5075 97.2859 77.2285 100.412V94.5262C85.0832 91.8242 93.0792 88.5777 99.0959 82.7862C108.312 73.9052 110.522 60.856 110.522 48.5661V22.541L116.093 18.7812H116.088Z",
    fill: "url(#paint20_linear_308_7963)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9336 22.5414C54.396 18.6926 68.7176 16.6819 77.2216 16.3467C85.7256 16.6819 100.047 18.6874 110.51 22.5414C99.9058 18.4361 88.3647 15.5613 77.2216 14.3359C66.0732 15.5613 54.5374 18.4361 43.9336 22.5414Z",
    fill: "url(#paint21_radial_308_7963)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3128 78.5985C85.4467 91.2392 68.9938 91.2392 55.1277 78.5985C48.2942 72.3724 45.2885 64.0255 44.1836 55.3906C44.9795 65.5126 47.8334 75.5352 55.3529 82.7824C61.3643 88.5739 69.3604 91.8257 77.2203 94.5225C85.0749 91.8205 93.0709 88.5739 99.0876 82.7824C106.612 75.5352 109.461 65.5074 110.257 55.3906C109.152 64.0203 106.146 72.3671 99.3128 78.5933V78.5985Z",
    fill: "url(#paint22_radial_308_7963)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3832 59.2168C63.2868 59.2168 51.3948 53.64 47.6822 46.0158C45.9908 42.544 45.9542 24.981 48.2949 23.6143C53.5889 20.5248 69.5495 17.8438 77.3832 17.8438C85.2169 17.8438 101.178 20.5248 106.472 23.6143C108.812 24.981 108.776 42.5492 107.084 46.0158C103.372 53.64 91.4797 59.2168 77.3832 59.2168Z",
    fill: "url(#paint23_radial_308_7963)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2245 48.7175C66.1285 48.7175 56.7657 45.0101 53.8438 39.936C52.5137 37.6267 52.4823 24.3157 54.3255 23.4098C58.4937 21.3519 70.3438 19.1055 77.2245 19.1055C84.1051 19.1055 95.9552 21.3519 100.123 23.4098C101.967 24.321 101.935 37.632 100.605 39.936C97.6832 45.0049 88.3205 48.7175 77.2245 48.7175Z",
    fill: "url(#paint24_radial_308_7963)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5499 46.823C37.5499 55.3846 38.0788 58.6992 40.299 66.4963C38.8695 60.6996 38.3563 54.5991 38.3563 48.5667V18.7819C49.9603 13.9068 62.8209 10.456 75.2994 8.95312C67.8636 9.79095 61.3181 10.8854 54.8616 12.5191C54.516 12.095 53.9399 11.8908 53.3849 12.0531C52.8508 12.2102 52.479 12.6553 52.3952 13.1685C50.9761 13.5612 49.5518 13.9801 48.1223 14.4304C47.5882 13.8701 46.7608 13.6345 45.9806 13.9016C45.2108 14.1634 44.6976 14.8389 44.6034 15.5929C42.4983 16.3208 40.3566 17.122 38.1573 17.9964L33.5859 15.6558L37.5499 18.9599V46.823Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M48.9105 25.5789C55.7183 25.5789 61.2371 20.0601 61.2371 13.2523C61.2371 6.44457 55.7183 0.925781 48.9105 0.925781C42.1028 0.925781 36.584 6.44457 36.584 13.2523C36.584 20.0601 42.1028 25.5789 48.9105 25.5789Z",
    fill: "url(#paint25_radial_308_7963)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6992 102.747L42.9696 109.094V102.747H21.6992Z",
    fill: "#CD74D7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.738 102.747L111.473 109.094V102.747H132.738Z",
    fill: "#CD74D7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9705 109.095L26.6328 114.934V104.225L42.9705 109.095Z",
    fill: "#E195E9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.473 109.095L127.805 114.934V104.225L111.473 109.095Z",
    fill: "#E195E9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8016 112.01V118.645L26.6328 114.932L34.8016 112.01Z",
    fill: "#D17FDA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.639 112.01V118.645L127.802 114.932L119.639 112.01Z",
    fill: "#D17FDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_308_7963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3418 76.8035H137.481L132.926 102.75H21.8923L17.3418 76.8035Z",
    fill: "#5F488A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_308_7963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5107 92.1423C36.2787 92.1423 35.9947 92.1183 35.6587 92.0703C35.6987 91.6543 35.7307 91.1023 35.7547 90.4143C35.7787 89.7183 35.7907 89.0703 35.7907 88.4703C35.7907 87.9583 35.7747 87.4383 35.7427 86.9103C34.7587 86.9183 34.1467 86.9703 33.9067 87.0663C33.8667 86.7863 33.8467 86.5503 33.8467 86.3583C33.8467 86.1983 33.8667 85.9983 33.9067 85.7583C34.2347 85.7903 34.6747 85.8183 35.2267 85.8423C35.7867 85.8583 36.3147 85.8663 36.8107 85.8663C38.0027 85.8663 38.7387 85.8143 39.0187 85.7103C39.0587 85.9663 39.0787 86.1783 39.0787 86.3463C39.0787 86.5543 39.0587 86.7783 39.0187 87.0183C38.5547 86.9783 37.9467 86.9463 37.1947 86.9223C37.1547 87.7463 37.1347 88.5543 37.1347 89.3463C37.1347 90.8103 37.1987 91.7183 37.3267 92.0703C37.1107 92.1183 36.8387 92.1423 36.5107 92.1423ZM42.5248 92.2263C41.9488 92.2263 41.4368 92.0983 40.9888 91.8423C40.5488 91.5783 40.2048 91.2143 39.9568 90.7503C39.7168 90.2863 39.5968 89.7503 39.5968 89.1423C39.5968 88.4623 39.7408 87.8583 40.0288 87.3303C40.3248 86.8023 40.7368 86.3903 41.2648 86.0943C41.7928 85.7983 42.3928 85.6503 43.0648 85.6503C43.6648 85.6503 44.1928 85.7823 44.6488 86.0463C45.1048 86.3103 45.4568 86.6823 45.7048 87.1623C45.9608 87.6343 46.0888 88.1823 46.0888 88.8063C46.0888 89.4703 45.9368 90.0623 45.6328 90.5823C45.3368 91.0943 44.9168 91.4983 44.3728 91.7943C43.8288 92.0823 43.2128 92.2263 42.5248 92.2263ZM42.8008 91.4463C43.3608 91.4463 43.8048 91.2543 44.1328 90.8703C44.4608 90.4783 44.6248 89.9503 44.6248 89.2863C44.6248 88.6703 44.4768 88.1463 44.1808 87.7143C43.8928 87.2743 43.5008 87.0023 43.0048 86.8983C42.6368 86.8983 42.3048 86.9983 42.0088 87.1983C41.7128 87.3903 41.4808 87.6623 41.3128 88.0143C41.1448 88.3583 41.0608 88.7503 41.0608 89.1903C41.0608 89.8703 41.2208 90.4183 41.5408 90.8343C41.8608 91.2423 42.2808 91.4463 42.8008 91.4463ZM48.0847 92.1423C47.8287 92.1423 47.5367 92.1183 47.2087 92.0703C47.2487 91.6783 47.2807 91.1423 47.3047 90.4623C47.3287 89.7743 47.3407 89.1303 47.3407 88.5303C47.3407 87.1623 47.2767 86.3223 47.1487 86.0103C47.4047 85.9143 47.7567 85.8383 48.2047 85.7823C48.6527 85.7183 49.1007 85.6863 49.5487 85.6863C50.3887 85.6863 51.0327 85.8703 51.4807 86.2383C51.9367 86.5983 52.1647 87.1183 52.1647 87.7983C52.1647 88.2543 52.0487 88.6623 51.8167 89.0223C51.5847 89.3743 51.2607 89.6503 50.8447 89.8503C50.4367 90.0503 49.9647 90.1503 49.4287 90.1503C49.1967 90.1503 48.9527 90.1303 48.6967 90.0903C48.7127 91.1143 48.7727 91.7743 48.8767 92.0703C48.6127 92.1183 48.3487 92.1423 48.0847 92.1423ZM49.8727 89.3823C50.1127 89.2543 50.3087 89.0583 50.4607 88.7943C50.6207 88.5223 50.7007 88.2223 50.7007 87.8943C50.7007 87.0463 50.2327 86.6223 49.2967 86.6223C49.0887 86.6223 48.9087 86.6423 48.7567 86.6823C48.7087 87.6263 48.6847 88.4463 48.6847 89.1423C49.2047 89.3023 49.6007 89.3823 49.8727 89.3823ZM58.5066 92.2023C57.6026 92.2023 56.9066 91.9423 56.4186 91.4223C55.9306 90.8943 55.6866 90.1463 55.6866 89.1783C55.6866 88.4983 55.8266 87.8943 56.1066 87.3663C56.3946 86.8303 56.7906 86.4143 57.2946 86.1183C57.8066 85.8223 58.3906 85.6743 59.0466 85.6743C59.7746 85.6743 60.3706 85.7703 60.8346 85.9623C60.8346 86.1943 60.7826 86.4623 60.6786 86.7663C60.5826 87.0623 60.4746 87.2783 60.3546 87.4143C60.0346 87.1583 59.6946 86.9423 59.3346 86.7663C58.9746 86.5903 58.6906 86.5023 58.4826 86.5023C58.2426 86.5663 58.0186 86.7183 57.8106 86.9583C57.6106 87.1903 57.4506 87.4743 57.3306 87.8103C57.2106 88.1463 57.1506 88.4903 57.1506 88.8423C57.1506 89.5703 57.3066 90.1183 57.6186 90.4863C57.9306 90.8463 58.3706 91.0263 58.9386 91.0263C59.2906 91.0263 59.6386 90.9823 59.9826 90.8943C60.3266 90.8063 60.6146 90.6863 60.8466 90.5343L61.0026 91.1343C60.7226 91.4543 60.3546 91.7143 59.8986 91.9143C59.4426 92.1063 58.9786 92.2023 58.5066 92.2023ZM64.556 92.2263C63.98 92.2263 63.468 92.0983 63.02 91.8423C62.58 91.5783 62.236 91.2143 61.988 90.7503C61.748 90.2863 61.628 89.7503 61.628 89.1423C61.628 88.4623 61.772 87.8583 62.06 87.3303C62.356 86.8023 62.768 86.3903 63.296 86.0943C63.824 85.7983 64.424 85.6503 65.096 85.6503C65.696 85.6503 66.224 85.7823 66.68 86.0463C67.136 86.3103 67.488 86.6823 67.736 87.1623C67.992 87.6343 68.12 88.1823 68.12 88.8063C68.12 89.4703 67.968 90.0623 67.664 90.5823C67.368 91.0943 66.948 91.4983 66.404 91.7943C65.86 92.0823 65.244 92.2263 64.556 92.2263ZM64.832 91.4463C65.392 91.4463 65.836 91.2543 66.164 90.8703C66.492 90.4783 66.656 89.9503 66.656 89.2863C66.656 88.6703 66.508 88.1463 66.212 87.7143C65.924 87.2743 65.532 87.0023 65.036 86.8983C64.668 86.8983 64.336 86.9983 64.04 87.1983C63.744 87.3903 63.512 87.6623 63.344 88.0143C63.176 88.3583 63.092 88.7503 63.092 89.1903C63.092 89.8703 63.252 90.4183 63.572 90.8343C63.892 91.2423 64.312 91.4463 64.832 91.4463ZM69.744 92.1423C69.584 92.1423 69.388 92.1183 69.156 92.0703C69.22 91.2383 69.252 90.0583 69.252 88.5303C69.252 87.0503 69.208 86.1223 69.12 85.7463C69.344 85.6983 69.604 85.6743 69.9 85.6743C70.132 85.6743 70.428 85.6983 70.788 85.7463C71.044 86.2503 71.436 86.9663 71.964 87.8943C72.5 88.8223 73 89.6703 73.464 90.4383C73.48 89.5903 73.488 88.9343 73.488 88.4703C73.488 86.9823 73.444 86.0743 73.356 85.7463C73.524 85.6983 73.692 85.6743 73.86 85.6743C74.036 85.6743 74.236 85.6983 74.46 85.7463C74.396 86.7863 74.364 87.9663 74.364 89.2863C74.364 90.7503 74.408 91.6783 74.496 92.0703C74.28 92.1183 74.024 92.1423 73.728 92.1423C73.456 92.1423 73.152 92.1183 72.816 92.0703C72.56 91.5823 72.168 90.8783 71.64 89.9583C71.12 89.0303 70.624 88.1703 70.152 87.3783C70.136 88.2263 70.128 88.8823 70.128 89.3463C70.128 90.7863 70.172 91.6943 70.26 92.0703C70.092 92.1183 69.92 92.1423 69.744 92.1423ZM77.8076 92.1423C77.5756 92.1423 77.2916 92.1183 76.9556 92.0703C76.9956 91.6543 77.0276 91.1023 77.0516 90.4143C77.0756 89.7183 77.0876 89.0703 77.0876 88.4703C77.0876 87.9583 77.0716 87.4383 77.0396 86.9103C76.0556 86.9183 75.4436 86.9703 75.2036 87.0663C75.1636 86.7863 75.1436 86.5503 75.1436 86.3583C75.1436 86.1983 75.1636 85.9983 75.2036 85.7583C75.5316 85.7903 75.9716 85.8183 76.5236 85.8423C77.0836 85.8583 77.6116 85.8663 78.1076 85.8663C79.2996 85.8663 80.0356 85.8143 80.3156 85.7103C80.3556 85.9663 80.3756 86.1783 80.3756 86.3463C80.3756 86.5543 80.3556 86.7783 80.3156 87.0183C79.8516 86.9783 79.2436 86.9463 78.4916 86.9223C78.4516 87.7463 78.4316 88.5543 78.4316 89.3463C78.4316 90.8103 78.4956 91.7183 78.6236 92.0703C78.4076 92.1183 78.1356 92.1423 77.8076 92.1423ZM82.0457 92.1423C81.7897 92.1423 81.4977 92.1183 81.1697 92.0703C81.2097 91.6783 81.2417 91.1383 81.2657 90.4503C81.2897 89.7543 81.3017 89.1143 81.3017 88.5303C81.3017 87.1623 81.2377 86.3223 81.1097 86.0103C81.3657 85.9143 81.7177 85.8383 82.1657 85.7823C82.6137 85.7183 83.0617 85.6863 83.5097 85.6863C84.3497 85.6863 84.9937 85.8703 85.4417 86.2383C85.8977 86.5983 86.1257 87.1183 86.1257 87.7983C86.1257 88.1903 86.0177 88.5423 85.8017 88.8543C85.5937 89.1583 85.3017 89.4023 84.9257 89.5863C85.5497 90.8103 86.0457 91.5783 86.4137 91.8903C86.1497 91.9863 85.8777 92.0503 85.5977 92.0823C85.3257 92.1223 85.0137 92.1423 84.6617 92.1423C84.5017 91.7183 84.1337 90.9703 83.5577 89.8983L83.3657 89.9103C83.2057 89.9103 82.9657 89.8903 82.6457 89.8503C82.6537 90.9783 82.7177 91.7183 82.8377 92.0703C82.5737 92.1183 82.3097 92.1423 82.0457 92.1423ZM83.8337 89.1423C84.0817 89.0143 84.2817 88.8423 84.4337 88.6263C84.5857 88.4103 84.6617 88.1663 84.6617 87.8943C84.6617 87.0463 84.1937 86.6223 83.2577 86.6223C83.0497 86.6223 82.8697 86.6423 82.7177 86.6823C82.6857 87.2903 82.6617 88.0263 82.6457 88.8903C83.1737 89.0583 83.5697 89.1423 83.8337 89.1423ZM88.198 92.1423C87.942 92.1423 87.65 92.1183 87.322 92.0703C87.41 90.8383 87.454 89.6583 87.454 88.5303C87.454 87.0583 87.39 86.1303 87.262 85.7463C87.526 85.6983 87.806 85.6743 88.102 85.6743C88.342 85.6743 88.618 85.6983 88.93 85.7463C88.89 86.1623 88.858 86.7183 88.834 87.4143C88.81 88.1023 88.798 88.7463 88.798 89.3463C88.798 90.8103 88.862 91.7183 88.99 92.0703C88.726 92.1183 88.462 92.1423 88.198 92.1423ZM92.8303 92.2143C92.3823 92.2143 91.9303 92.1823 91.4743 92.1183C91.0183 92.0623 90.6383 91.9863 90.3343 91.8903C90.3663 91.5463 90.3903 91.0383 90.4063 90.3663C90.4303 89.6943 90.4423 89.0423 90.4423 88.4103C90.4423 87.0983 90.3783 86.2983 90.2503 86.0103C90.5543 85.9143 90.9383 85.8383 91.4023 85.7823C91.8663 85.7183 92.3263 85.6863 92.7823 85.6863C93.5823 85.6863 94.1943 85.8343 94.6183 86.1303C95.0503 86.4183 95.2663 86.8343 95.2663 87.3783C95.2663 87.6583 95.1783 87.9143 95.0023 88.1463C94.8343 88.3783 94.5943 88.5703 94.2823 88.7223C94.6823 88.8823 94.9943 89.1023 95.2183 89.3823C95.4503 89.6623 95.5663 89.9823 95.5663 90.3423C95.5663 90.9423 95.3303 91.4063 94.8583 91.7343C94.3863 92.0543 93.7103 92.2143 92.8303 92.2143ZM91.7983 88.5903C92.1023 88.5183 92.4423 88.4823 92.8183 88.4823L93.1663 88.4943C93.3663 88.3663 93.5223 88.2183 93.6343 88.0503C93.7463 87.8743 93.8023 87.6943 93.8023 87.5103C93.8023 86.9183 93.4183 86.6223 92.6503 86.6223C92.3783 86.6223 92.1143 86.6583 91.8583 86.7303C91.8263 87.4263 91.8063 88.0463 91.7983 88.5903ZM92.6983 91.5183C93.6343 91.5183 94.1023 91.1263 94.1023 90.3423C94.1023 90.0703 94.0183 89.8303 93.8503 89.6223C93.6823 89.4143 93.4423 89.2503 93.1303 89.1303C92.8183 89.1303 92.3703 89.2303 91.7863 89.4303C91.7863 90.2223 91.8063 90.8703 91.8463 91.3743C92.1103 91.4703 92.3943 91.5183 92.6983 91.5183ZM99.1696 92.1303C98.3856 92.1303 97.7736 91.9183 97.3336 91.4943C96.9016 91.0623 96.6856 90.4543 96.6856 89.6703C96.6856 88.8463 96.6696 88.0463 96.6376 87.2703C96.6056 86.4943 96.5576 85.9863 96.4936 85.7463C96.7736 85.6983 97.0536 85.6743 97.3336 85.6743C97.5736 85.6743 97.8496 85.6983 98.1616 85.7463C98.1136 86.8663 98.0896 88.1343 98.0896 89.5503C98.0896 90.5903 98.5296 91.1103 99.4096 91.1103C100.37 91.1103 100.85 90.6423 100.85 89.7063C100.85 87.5223 100.818 86.2023 100.754 85.7463C100.938 85.6983 101.118 85.6743 101.294 85.6743C101.454 85.6743 101.642 85.6983 101.858 85.7463C101.834 86.2023 101.81 86.8143 101.786 87.5823C101.77 88.3503 101.762 89.0263 101.762 89.6103C101.762 90.3463 101.562 90.9503 101.162 91.4223C100.77 91.8943 100.106 92.1303 99.1696 92.1303ZM105.124 92.1423C104.892 92.1423 104.608 92.1183 104.272 92.0703C104.312 91.6543 104.344 91.1023 104.368 90.4143C104.392 89.7183 104.404 89.0703 104.404 88.4703C104.404 87.9583 104.388 87.4383 104.356 86.9103C103.372 86.9183 102.76 86.9703 102.52 87.0663C102.48 86.7863 102.46 86.5503 102.46 86.3583C102.46 86.1983 102.48 85.9983 102.52 85.7583C102.848 85.7903 103.288 85.8183 103.84 85.8423C104.4 85.8583 104.928 85.8663 105.424 85.8663C106.616 85.8663 107.352 85.8143 107.632 85.7103C107.672 85.9663 107.692 86.1783 107.692 86.3463C107.692 86.5543 107.672 86.7783 107.632 87.0183C107.168 86.9783 106.56 86.9463 105.808 86.9223C105.768 87.7463 105.748 88.5543 105.748 89.3463C105.748 90.8103 105.812 91.7183 105.94 92.0703C105.724 92.1183 105.452 92.1423 105.124 92.1423ZM111.138 92.2263C110.562 92.2263 110.05 92.0983 109.602 91.8423C109.162 91.5783 108.818 91.2143 108.57 90.7503C108.33 90.2863 108.21 89.7503 108.21 89.1423C108.21 88.4623 108.354 87.8583 108.642 87.3303C108.938 86.8023 109.35 86.3903 109.878 86.0943C110.406 85.7983 111.006 85.6503 111.678 85.6503C112.278 85.6503 112.806 85.7823 113.262 86.0463C113.718 86.3103 114.07 86.6823 114.318 87.1623C114.574 87.6343 114.702 88.1823 114.702 88.8063C114.702 89.4703 114.55 90.0623 114.246 90.5823C113.95 91.0943 113.53 91.4983 112.986 91.7943C112.442 92.0823 111.826 92.2263 111.138 92.2263ZM111.414 91.4463C111.974 91.4463 112.418 91.2543 112.746 90.8703C113.074 90.4783 113.238 89.9503 113.238 89.2863C113.238 88.6703 113.09 88.1463 112.794 87.7143C112.506 87.2743 112.114 87.0023 111.618 86.8983C111.25 86.8983 110.918 86.9983 110.622 87.1983C110.326 87.3903 110.094 87.6623 109.926 88.0143C109.758 88.3583 109.674 88.7503 109.674 89.1903C109.674 89.8703 109.834 90.4183 110.154 90.8343C110.474 91.2423 110.894 91.4463 111.414 91.4463ZM116.698 92.1423C116.442 92.1423 116.15 92.1183 115.822 92.0703C115.862 91.6783 115.894 91.1383 115.918 90.4503C115.942 89.7543 115.954 89.1143 115.954 88.5303C115.954 87.1623 115.89 86.3223 115.762 86.0103C116.018 85.9143 116.37 85.8383 116.818 85.7823C117.266 85.7183 117.714 85.6863 118.162 85.6863C119.002 85.6863 119.646 85.8703 120.094 86.2383C120.55 86.5983 120.778 87.1183 120.778 87.7983C120.778 88.1903 120.67 88.5423 120.454 88.8543C120.246 89.1583 119.954 89.4023 119.578 89.5863C120.202 90.8103 120.698 91.5783 121.066 91.8903C120.802 91.9863 120.53 92.0503 120.25 92.0823C119.978 92.1223 119.666 92.1423 119.314 92.1423C119.154 91.7183 118.786 90.9703 118.21 89.8983L118.018 89.9103C117.858 89.9103 117.618 89.8903 117.298 89.8503C117.306 90.9783 117.37 91.7183 117.49 92.0703C117.226 92.1183 116.962 92.1423 116.698 92.1423ZM118.486 89.1423C118.734 89.0143 118.934 88.8423 119.086 88.6263C119.238 88.4103 119.314 88.1663 119.314 87.8943C119.314 87.0463 118.846 86.6223 117.91 86.6223C117.702 86.6223 117.522 86.6423 117.37 86.6823C117.338 87.2903 117.314 88.0263 117.298 88.8903C117.826 89.0583 118.222 89.1423 118.486 89.1423Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_308_7963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.5325 51.086C92.5507 51.1123 92.5695 51.1381 92.5869 51.1651C92.7301 51.3825 93.0629 51.4829 93.0493 51.7871C93.0331 52.1557 92.8732 52.4877 92.6556 52.7887C92.4885 53.0197 92.267 53.1921 92.0242 53.3297C91.6778 53.5259 91.33 53.5684 91.0555 53.1708C91.0237 53.2461 91.0043 53.2686 91.0095 53.2815C91.0775 53.4494 91.3061 53.5414 91.2245 53.7819C91.0749 54.2232 90.8968 54.6439 90.4843 54.9115C90.3678 54.9868 90.237 55.0408 90.1113 55.102C89.4165 55.4371 89.4055 55.4345 88.8337 54.9167C88.7877 54.8749 88.7275 54.8479 88.6738 54.8144C88.6401 54.761 88.6148 54.6999 88.5721 54.6562C87.0166 53.0801 85.4573 51.5079 83.9051 49.9293C83.7691 49.791 83.7012 49.8206 83.5742 49.9364C83.2673 50.2162 83.0167 50.5591 82.6508 50.774C82.5517 50.4858 82.3413 50.2638 82.1826 50.0117C81.4567 48.8608 81.4982 47.6914 82.0654 46.5006C82.1904 46.2388 82.3147 45.9725 82.5258 45.7699C82.6838 45.6181 82.7091 45.5029 82.5258 45.3646C82.3355 45.2218 82.3497 45.0919 82.5245 44.9252C83.852 43.658 85.1737 42.3849 86.4915 41.1074C86.6469 40.9568 86.7686 40.9556 86.8839 41.1247C87.0775 41.4091 87.277 41.3962 87.6053 41.2907C88.5397 40.9897 89.3569 41.3557 90.1029 41.8973C90.4319 42.1366 90.7323 42.4145 91.0464 42.6751C91.0775 42.7175 91.1027 42.7651 91.1397 42.8018C92.7294 44.383 94.3198 45.9635 95.9109 47.5434C95.9627 47.5949 96.006 47.6637 96.0961 47.654C96.1148 47.6914 96.1233 47.7422 96.153 47.7647C96.6679 48.1519 96.526 48.6402 96.3182 49.0944C96.1006 49.571 95.668 49.7704 95.148 49.8142C94.8877 49.8361 94.7258 49.6476 94.5218 49.5633C94.4668 49.645 94.5121 49.69 94.5503 49.717C94.8916 49.957 94.8495 50.2799 94.7375 50.6074C94.5613 51.122 94.0621 51.6649 93.4715 51.6186C93.2999 51.6051 93.1633 51.5729 93.0448 51.4436C92.9075 51.2944 92.7534 51.1606 92.6064 51.0197C92.1226 50.5199 91.6396 50.02 91.1558 49.5208C91.0438 49.3928 90.9415 49.2539 90.779 49.1844C90.8703 49.3285 90.9693 49.463 91.1137 49.5537C91.5593 50.0908 92.0495 50.5861 92.5338 51.0872L92.5325 51.086ZM90.7246 52.8267C90.0783 52.2445 89.4314 51.6623 88.7851 51.0802C89.4411 51.6533 90.0084 52.314 90.6553 52.9006C90.6889 52.9174 90.742 52.9566 90.7524 52.947C90.8075 52.8987 90.7647 52.8601 90.7246 52.826V52.8267ZM94.3023 49.3594C93.7538 48.7875 93.2054 48.2156 92.6556 47.645C92.6096 47.5968 92.5636 47.5009 92.4807 47.6C92.4205 47.6714 92.4885 47.7158 92.5325 47.757C93.1192 48.3044 93.6535 48.9065 94.2738 49.4192C94.3004 49.463 94.3451 49.5176 94.3839 49.4655C94.4131 49.4263 94.3418 49.3883 94.303 49.36L94.3023 49.3594Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4133 44.2921C63.364 44.2404 63.3078 44.193 63.2659 44.1356C63.1073 43.9192 62.7444 43.7913 62.8375 43.4657C62.9774 42.9761 63.1879 42.5053 63.695 42.2626C63.7513 42.2358 63.8106 42.2165 63.8668 42.1903C64.3598 41.9591 64.8033 42.0323 65.1972 42.4098C65.2184 42.4298 65.2528 42.436 65.2815 42.4485C65.2946 42.4766 65.3009 42.5109 65.3209 42.5314C66.8536 44.0919 68.3889 45.6499 69.9179 47.2141C70.036 47.3351 70.0941 47.2896 70.1884 47.1979C70.4626 46.9316 70.7455 46.674 71.0247 46.4133C71.5706 46.9684 71.9198 47.6382 72.0409 48.3972C72.2077 49.4375 71.8392 50.3556 71.2439 51.1882C71.1296 51.3485 71.0691 51.4558 71.2308 51.6067C71.4095 51.7733 71.3764 51.9042 71.1827 52.0564C70.9466 52.241 70.7418 52.4655 70.5263 52.6757C69.4776 53.698 68.4257 54.7177 67.3852 55.7486C67.2221 55.9108 67.1341 55.9027 67.0098 55.7256C66.8411 55.4848 66.6713 55.4268 66.344 55.5534C65.5339 55.8665 64.8006 55.5378 64.1085 55.1162C63.6982 54.8661 63.3721 54.5119 62.9949 54.2206C62.9599 54.1033 62.8562 54.0422 62.7775 53.963C61.3109 52.4955 59.8425 51.0292 58.3728 49.5641C58.301 49.4924 58.2454 49.3976 58.1367 49.3689C58.0318 49.1506 57.7326 49.0596 57.7445 48.7658C57.7738 48.0467 58.0068 47.5802 58.7526 47.342C58.9724 47.2715 59.0405 47.2883 59.6483 47.4754C59.1161 46.8892 59.4415 46.4183 59.7982 45.9592C60.1935 45.4503 60.7694 45.4204 61.2222 45.8732C61.3097 45.9605 61.4028 46.0428 61.4933 46.127C62.043 46.6952 62.592 47.2627 63.1416 47.8309C63.176 47.8746 63.1966 47.9419 63.2759 47.9076C63.2559 47.8627 63.2385 47.8166 63.1816 47.8066C62.6626 47.2047 62.121 46.6228 61.5608 46.059C61.5077 45.996 61.4652 45.9168 61.3996 45.8725C60.9799 45.5913 61.0442 45.2301 61.2066 44.8391C61.3946 44.3857 61.7238 44.0682 62.1473 43.8443C62.4552 43.6815 62.6794 43.7314 62.9312 43.9784C63.0561 44.1013 63.1872 44.2185 63.3153 44.3383C63.7107 44.8591 64.2153 45.2769 64.6532 45.7578C64.7881 45.9062 64.9286 46.0503 65.066 46.1962L65.1429 46.1201C64.5664 45.5108 63.9905 44.9015 63.414 44.2921H63.4133ZM59.8775 47.6819C59.85 47.6625 59.8225 47.6432 59.7944 47.6251C59.7944 47.6251 59.7838 47.6388 59.7782 47.6463L59.8681 47.6918C59.8731 47.7218 59.8669 47.7642 59.8844 47.7804C60.4396 48.2974 60.9562 48.8513 61.4621 49.4151C61.5027 49.4606 61.5427 49.5236 61.6101 49.4581C61.6932 49.3764 61.6051 49.3321 61.5602 49.2866C61.2666 48.9935 60.9787 48.6935 60.6732 48.4128C60.4084 48.169 60.1985 47.8646 59.8775 47.6825V47.6819Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5811 63.785C74.4506 63.8144 74.3721 63.9195 74.2979 64.0128C74.0969 64.2657 73.8582 64.2682 73.5812 64.1787C73.0698 64.0134 72.671 63.7143 72.4211 63.2273C72.2344 62.8637 72.2771 62.6321 72.5584 62.3373C72.6617 62.2291 72.8144 62.1546 72.8336 61.9781C72.9171 62.0144 72.9628 61.9574 73.0148 61.9061C73.5515 61.3747 74.0901 60.8446 74.6274 60.3145C74.6652 60.277 74.7004 60.2388 74.633 60.1574C74.0357 60.7689 73.3796 61.3147 72.82 61.9624C72.6778 62.0307 72.5584 62.1327 72.4638 62.2547C72.2734 62.5007 72.0557 62.5101 71.7812 62.4093C71.0076 62.1258 70.6718 61.5068 70.4956 60.7545C70.461 60.6074 70.5562 60.5217 70.6372 60.4303C70.7516 60.3007 70.9087 60.21 70.9791 60.041C71.1801 59.9609 71.2914 59.7763 71.4367 59.6329C72.833 58.2516 74.2206 56.8609 75.6248 55.4878C75.8289 55.2881 75.8122 55.1886 75.6205 55.0115C75.3565 54.7674 75.1209 54.4914 74.8735 54.2291C75.2062 54.022 75.5333 53.8054 75.8722 53.6101C76.8028 53.0744 77.7582 53.1157 78.7228 53.51C79.0957 53.6627 79.4679 53.8217 79.7536 54.1208C79.8903 54.2642 79.9781 54.1578 80.0615 54.0783C80.2229 53.9243 80.3392 53.94 80.4969 54.1046C81.7224 55.3845 82.9554 56.6575 84.1928 57.9255C84.3325 58.0682 84.3282 58.1659 84.1785 58.2729C83.9312 58.45 83.8972 58.6328 83.9943 58.9501C84.2775 59.8758 83.9528 60.6907 83.4007 61.4261C83.1644 61.7403 82.8998 62.0325 82.6481 62.3342C82.5993 62.3705 82.5442 62.4012 82.5022 62.4437C80.9903 63.9734 79.479 65.5043 77.9678 67.0345C77.9171 67.0859 77.8565 67.129 77.8689 67.2148C77.8237 67.2379 77.7724 67.2536 77.7353 67.2861C77.3488 67.6204 76.8257 67.636 76.3477 67.3249C75.9934 67.094 75.7498 66.4644 75.8357 66.0682C75.8672 65.923 76.0064 65.8397 76.0249 65.7058C75.9668 65.6495 75.9229 65.6701 75.9019 65.7008C75.6267 66.0976 75.2835 65.9699 74.9416 65.8291C74.6788 65.7202 74.4704 65.5349 74.2929 65.3153C73.9633 64.9053 73.9868 64.5029 74.3523 64.1348C74.4469 64.0397 74.5347 63.9383 74.6262 63.8394C75.1691 63.3112 75.712 62.783 76.2543 62.2541C76.276 62.2303 76.2976 62.2065 76.3186 62.1834C76.3693 62.1489 76.438 62.1264 76.4058 62.0382C76.3415 62.0538 76.3026 62.0957 76.2828 62.1565C76.2451 62.159 76.2228 62.1784 76.2197 62.2178C75.9841 62.4293 75.738 62.6309 75.5148 62.8556C75.2056 63.1666 74.8377 63.4176 74.5804 63.7825L74.5811 63.785ZM76.1115 65.5531C76.1492 65.5299 76.1863 65.5068 76.224 65.4842C76.7688 64.936 77.3105 64.3833 77.8874 63.8689C77.9313 63.8294 78.0327 63.7956 77.9511 63.7024C77.8886 63.631 77.8466 63.6848 77.8039 63.7305C77.2585 64.3063 76.676 64.8446 76.1634 65.4523C76.1387 65.4786 76.1146 65.5049 76.0898 65.5318C76.0781 65.5449 76.0546 65.5662 76.0571 65.5694C76.0855 65.61 76.0973 65.5737 76.1121 65.5543L76.1115 65.5531Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1792 31.3155C78.2299 31.2824 78.2869 31.2567 78.3308 31.2161C78.696 30.8779 78.891 30.8423 79.3403 31.0498C79.5866 31.1636 79.7989 31.3286 79.9654 31.5424C80.299 31.9712 80.2662 32.3825 79.8825 32.77C79.7958 32.8576 79.716 32.9519 79.633 33.0426C79.1818 33.4157 78.7851 33.847 78.3692 34.2577C78.3246 34.3008 78.2801 34.3446 78.2355 34.3877C78.2182 34.4046 78.2015 34.4209 78.1841 34.4377C78.1328 34.494 78.0814 34.5509 78.03 34.6071C77.9694 34.6296 77.9242 34.6671 77.9081 34.734C77.8598 34.7321 77.8419 34.7646 77.8351 34.8047C77.8338 34.8115 77.8604 34.8315 77.8629 34.8297C77.8951 34.8053 77.9601 34.7934 77.9062 34.7309C78.0053 34.784 78.0176 34.674 78.0709 34.6415C78.1204 34.5896 78.1699 34.5377 78.2194 34.4859L78.2825 34.4252C78.342 34.4027 78.3853 34.3634 78.4088 34.3027C78.852 33.9221 79.2908 33.537 79.6807 33.0988C79.7246 33.0713 79.7692 33.0457 79.8113 33.0163C79.9858 32.8938 80.0824 32.6244 80.3102 32.6275C80.6295 32.6319 80.9501 32.74 81.2014 32.9413C81.6309 33.2845 82.071 33.6458 81.8971 34.3102C81.8655 34.4302 81.9355 34.4221 82.0153 34.419C82.6373 34.3971 83.0805 34.7003 83.4067 35.2091C83.4679 35.3047 83.5082 35.4135 83.557 35.5166C83.8597 36.1523 83.8548 36.1817 83.3677 36.6911C83.3324 36.728 83.3039 36.7718 83.2717 36.813C83.1517 36.9249 83.0279 37.0337 82.9109 37.1493C81.4713 38.5745 80.0341 40.0028 78.592 41.4248C78.4571 41.5573 78.4199 41.6386 78.5784 41.7898C78.8458 42.0449 79.0859 42.3299 79.3372 42.6031C78.6762 43.1794 77.9291 43.6219 77.0503 43.6513C76.1831 43.6807 75.3649 43.4025 74.6593 42.8643C74.4613 42.7131 74.301 42.5956 74.098 42.8537C73.9692 43.0181 73.8646 42.8818 73.7718 42.7856C72.9876 41.9736 72.2034 41.1616 71.4211 40.3478C70.9693 39.8771 70.5311 39.3939 70.0694 38.9339C69.8992 38.7639 69.9326 38.6463 70.1009 38.5451C70.3689 38.3844 70.3522 38.2125 70.2581 37.9269C69.9951 37.1274 70.2365 36.3917 70.6673 35.7073C70.9334 35.2841 71.2701 34.9184 71.6012 34.549C71.6414 34.5184 71.686 34.4927 71.7213 34.4571C73.2401 32.9238 74.7577 31.3899 76.276 29.856C76.3261 29.8053 76.388 29.7616 76.3917 29.6797C76.4431 29.6472 76.5007 29.6209 76.5452 29.5803C76.9259 29.2328 77.4458 29.2278 77.9384 29.5697C78.311 29.8285 78.5487 30.4835 78.3927 30.8642C78.3308 31.0148 78.2281 31.148 78.1445 31.2892C78.0981 31.3211 78.0511 31.3524 78.0046 31.3836C77.8877 31.5143 77.7775 31.6518 77.6519 31.7737C77.2285 32.185 76.7996 32.5906 76.375 33.0007C76.3292 33.0451 76.2302 33.0857 76.31 33.1726C76.3917 33.2613 76.4344 33.1626 76.479 33.117C77.0175 32.5581 77.5547 31.9981 78.0919 31.438L78.1786 31.318L78.1792 31.3155ZM81.4416 34.9265C81.5752 34.8053 81.7424 34.7115 81.8191 34.4677C81.605 34.5765 81.4855 34.6996 81.4038 34.8653C81.3599 34.8884 81.3079 34.9034 81.2738 34.9365C80.7279 35.4704 80.1845 36.006 79.6405 36.5411C79.6046 36.5767 79.5594 36.608 79.6231 36.7205C80.2359 36.1161 80.8387 35.5216 81.4416 34.9272V34.9265Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9236 67.2917C77.9107 67.2028 77.9715 67.1574 78.0219 67.1049C79.5224 65.5192 81.0229 63.9329 82.5241 62.3479C82.5665 62.3031 82.6205 62.272 82.669 62.2344C83.9153 63.5879 85.1617 64.9414 86.4179 66.3059C84.8074 67.9603 83.2044 69.607 81.5939 71.2614C80.3654 69.9332 79.1448 68.6127 77.9236 67.2923V67.2917Z",
    fill: "#D5D8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3294 29.4903C76.325 29.5767 76.2631 29.6228 76.2126 29.6762C74.6809 31.2936 73.1486 32.911 71.6157 34.5278C71.5801 34.5653 71.5351 34.593 71.4945 34.6247C70.3208 33.3506 69.152 32.0713 67.9695 30.8065C67.789 30.6134 67.7871 30.5205 67.9739 30.3313C69.48 28.8029 70.9792 27.2659 72.4677 25.7183C72.6489 25.5298 72.7232 25.5813 72.8694 25.7414C74.0181 26.9957 75.175 28.2413 76.33 29.4903H76.3294Z",
    fill: "#D5D8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0593 47.3701C95.9727 47.3795 95.9309 47.3125 95.881 47.2623C94.3497 45.7235 92.819 44.184 91.289 42.6438C91.2534 42.6081 91.2285 42.5618 91.1992 42.5204C92.4052 41.3424 93.6131 40.1676 94.8128 38.9834C94.953 38.8449 95.0222 38.833 95.1662 38.9834C96.6358 40.5153 98.1116 42.0417 99.595 43.5605C99.7446 43.714 99.7159 43.7848 99.5806 43.9164C98.4027 45.0637 97.2322 46.2178 96.0593 47.3695V47.3701Z",
    fill: "#D5D8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1692 49.4922C58.2791 49.5206 58.3344 49.6172 58.4066 49.6898C59.8846 51.1728 61.3606 52.6564 62.836 54.1426C62.9158 54.2228 63.0201 54.2846 63.0546 54.4033C61.8782 55.5511 60.698 56.6951 59.5297 57.8517C59.3475 58.0316 59.2558 58.0373 59.0743 57.8472C57.6115 56.3182 56.1392 54.7992 54.6613 53.2846C54.5124 53.1318 54.5331 53.0617 54.6738 52.9254C55.8433 51.7858 57.0053 50.6381 58.1692 49.4928V49.4922Z",
    fill: "#D5D8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.01 46.4757C70.7266 46.7417 70.4394 47.0046 70.161 47.2763C70.0653 47.3698 70.0063 47.4157 69.8864 47.2928C68.3336 45.6974 66.7757 44.1077 65.2196 42.5149C65.1993 42.4939 65.193 42.4589 65.1797 42.4302C66.1707 41.4629 67.1656 40.4995 68.1497 39.5245C68.3025 39.3731 68.3881 39.3533 68.5454 39.5169C70.0399 41.0722 71.5395 42.6224 73.046 44.1663C73.1893 44.3133 73.1691 44.3782 73.0334 44.5074C72.353 45.1565 71.684 45.8177 71.0107 46.4751L71.01 46.4757Z",
    fill: "#D5D8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9859 50.4289C83.3241 50.2141 83.5547 49.8713 83.838 49.5915C83.9551 49.4757 84.0178 49.4461 84.1433 49.5844C85.5755 51.1634 87.0143 52.7353 88.4496 54.3104C88.4896 54.3541 88.5123 54.4158 88.5434 54.4686C87.6292 55.4237 86.7108 56.3743 85.805 57.339C85.655 57.4985 85.5755 57.4947 85.4357 57.339C84.0322 55.7742 82.6244 54.2139 81.2119 52.6581C81.081 52.514 81.0691 52.4375 81.2131 52.2902C81.8112 51.6779 82.3962 51.0502 82.9859 50.4282V50.4289Z",
    fill: "#D5D8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3526 42.69C79.0907 42.4104 78.8403 42.118 78.5616 41.8557C78.3964 41.7006 78.4351 41.6172 78.5758 41.4812C80.0798 40.0224 81.5781 38.5571 83.0783 37.095C83.2002 36.9764 83.3286 36.8648 83.4544 36.75C84.401 37.7234 85.3443 38.7001 86.298 39.6665C86.4503 39.821 86.4645 39.9089 86.3019 40.0653C84.7269 41.5761 83.1563 43.0921 81.5923 44.6138C81.4477 44.7549 81.38 44.7453 81.2445 44.6048C80.6212 43.9597 79.985 43.3274 79.3526 42.69Z",
    fill: "#D5D8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.852 54.0762C75.1129 54.3486 75.3615 54.6353 75.64 54.8889C75.8423 55.0729 75.8599 55.1763 75.6446 55.3837C74.1631 56.8101 72.7 58.2547 71.2263 59.6895C71.0737 59.8384 70.9556 60.0302 70.7436 60.1134C69.8212 59.1662 68.9027 58.2157 67.9731 57.2749C67.8179 57.1176 67.7663 57.0298 67.9562 56.8484C69.5453 55.3258 71.1252 53.7941 72.7006 52.2578C72.8533 52.1089 72.9328 52.1128 73.0777 52.2649C73.6608 52.8761 74.2584 53.4735 74.8507 54.0762H74.852Z",
    fill: "#D5D8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.672 44.1797C64.1745 44.8594 64.6764 45.5391 65.1789 46.2188L65.112 46.3037C64.9917 46.1409 64.8697 45.9802 64.7521 45.8146C64.3705 45.2782 63.9306 44.8114 63.5859 44.2312C63.6148 44.2145 63.6436 44.1971 63.6725 44.1804L63.672 44.1797Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0156 47.8974C62.4972 47.2164 61.9794 46.5353 61.4609 45.8549C61.4821 45.828 61.5034 45.8004 61.5252 45.7734C62.0536 46.45 62.5638 47.1468 63.0539 47.8683C63.041 47.878 63.0286 47.8877 63.0162 47.8974H63.0156Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3293 62.2706C75.8126 62.7896 75.296 63.3085 74.7793 63.8274C74.7652 63.8089 74.751 63.7899 74.7363 63.7714C74.9811 63.4136 75.3307 63.1664 75.6255 62.8609C75.838 62.6402 76.0716 62.4422 76.2964 62.2344C76.307 62.2473 76.3176 62.259 76.3293 62.2706Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7155 51.0852C92.1976 50.5762 91.6749 50.0718 91.1992 49.5256C91.2144 49.5144 91.229 49.5033 91.2442 49.4922C91.76 50.0005 92.2764 50.5088 92.7922 51.0165C92.7666 51.0394 92.7411 51.0623 92.7155 51.0852Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4536 34.0553C78.7904 33.7092 79.1117 33.3463 79.477 33.0312C79.4896 33.0465 79.5026 33.0623 79.5151 33.0781C79.1999 33.4474 78.8445 33.7724 78.4852 34.0933C78.4752 34.0801 78.4647 34.068 78.4531 34.0558L78.4536 34.0553Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.351 49.4912C93.6369 48.9065 93.022 48.2198 92.3468 47.5954C92.2961 47.5485 92.2178 47.4979 92.2871 47.4164C92.3825 47.3034 92.4355 47.4128 92.4884 47.4678C93.1212 48.1185 93.7525 48.7715 94.3838 49.423C94.3726 49.4457 94.3622 49.4684 94.351 49.4905V49.4912Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6103 52.6789C90.0795 52.165 89.613 51.5875 89.0742 51.0859C89.605 51.5954 90.1364 52.1048 90.6672 52.6142C90.6481 52.6356 90.6289 52.6575 90.6103 52.6789Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8784 47.3672C60.2622 47.5816 60.5131 47.9399 60.8297 48.227C61.1948 48.5574 61.539 48.9106 61.8899 49.2557C61.9444 49.3093 62.0497 49.3615 61.9497 49.4577C61.869 49.5355 61.8212 49.4606 61.7727 49.407C61.1679 48.7432 60.5504 48.0912 59.8866 47.4825C59.8657 47.4634 59.8732 47.4134 59.8672 47.3782L59.8784 47.3672Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6133 62.2061C73.2553 61.4551 74.0081 60.8223 74.6934 60.1133C74.7708 60.2076 74.731 60.2519 74.687 60.2954C74.0698 60.9108 73.4526 61.5254 72.8368 62.1408C72.7772 62.2003 72.7247 62.2656 72.6289 62.2243L72.6133 62.2061Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3306 65.3931C76.7795 64.8603 77.2902 64.3883 77.7672 63.8834C77.8051 63.8434 77.8414 63.7956 77.8961 63.8587C77.9676 63.9405 77.8788 63.9701 77.8403 64.0047C77.3351 64.4564 76.8607 64.9404 76.3837 65.4211C76.3658 65.4118 76.3479 65.4019 76.3301 65.3926L76.3306 65.3931Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9231 31.485C77.4508 31.9738 76.9785 32.4626 76.5051 32.9504C76.4659 32.9908 76.4289 33.077 76.3566 32.9989C76.2864 32.9231 76.3734 32.8876 76.4137 32.8489C76.787 32.491 77.1646 32.1375 77.5362 31.7779C77.6461 31.6716 77.7435 31.5515 77.8458 31.4375C77.8714 31.4528 77.897 31.4686 77.9225 31.4844L77.9231 31.485Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6396 34.6958C80.9477 35.3764 80.2557 36.057 79.5524 36.749C79.4792 36.6202 79.5311 36.5844 79.5723 36.5436C80.1967 35.931 80.8205 35.317 81.4471 34.7066C81.4862 34.6687 81.5459 34.6515 81.5963 34.625C81.6105 34.6486 81.6254 34.6722 81.6396 34.6958Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_308_7963",
    x: 17.3418,
    y: 76.8037,
    width: 120.139,
    height: 28.9463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_308_7963"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_308_7963",
    x: 29.8467,
    y: 85.6504,
    width: 95.2193,
    height: 14.5762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_7963"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_7963",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_308_7963",
    x: 50.5586,
    y: 24.5977,
    width: 53.1366,
    height: 54.6641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_7963"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_7963",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0166667 0 0 0 0 0.0166667 0 0 0 0 0.0166667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_308_7963"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_308_7963",
    x1: 105.172,
    y1: 33.3361,
    x2: 153.735,
    y2: 33.3361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_308_7963",
    x1: 105.172,
    y1: 37.2448,
    x2: 149.702,
    y2: 37.2448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_308_7963",
    x1: 0.710286,
    y1: 45.7234,
    x2: 143.382,
    y2: 45.7234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_308_7963",
    x1: 0.713578,
    y1: 49.6282,
    x2: 139.359,
    y2: 49.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_308_7963",
    x1: 0.713556,
    y1: 58.1067,
    x2: 133.033,
    y2: 58.1067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_308_7963",
    x1: 0.713564,
    y1: 62.0129,
    x2: 129.006,
    y2: 62.0129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_308_7963",
    x1: 0.712891,
    y1: 33.3361,
    x2: 49.2756,
    y2: 33.3361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_308_7963",
    x1: 4.74219,
    y1: 37.2448,
    x2: 49.278,
    y2: 37.2448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_308_7963",
    x1: 11.0677,
    y1: 45.7234,
    x2: 1.23895,
    y2: 45.7234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_308_7963",
    x1: 15.0938,
    y1: 49.6282,
    x2: 1.23815,
    y2: 49.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_308_7963",
    x1: 21.4141,
    y1: 58.1067,
    x2: 1.23809,
    y2: 58.1067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_308_7963",
    x1: 25.4453,
    y1: 62.0129,
    x2: 1.23729,
    y2: 62.0129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_308_7963",
    x1: 77.2235,
    y1: 95.6688,
    x2: 77.2235,
    y2: 13.2526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40526F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717F8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_308_7963",
    x1: 32.7923,
    y1: 10.9599,
    x2: 77.2235,
    y2: 10.9599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_308_7963",
    x1: 38.3633,
    y1: 15.6412,
    x2: 77.2228,
    y2: 15.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_308_7963",
    x1: 55.0092,
    y1: 106.289,
    x2: 55.0092,
    y2: 15.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_308_7963",
    x1: 57.797,
    y1: 100.412,
    x2: 57.797,
    y2: 18.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_308_7963",
    x1: 77.2233,
    y1: 10.9599,
    x2: 121.66,
    y2: 10.9599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_308_7963",
    x1: 77.2227,
    y1: 0.926855,
    x2: 116.087,
    y2: 0.926855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_308_7963",
    x1: 99.4408,
    y1: 106.289,
    x2: 99.4408,
    y2: 15.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_308_7963",
    x1: 96.6557,
    y1: 100.412,
    x2: 96.6557,
    y2: 18.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_308_7963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.2216 70.5019) scale(74.682 74.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DFE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C3C9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFB7D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_308_7963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.0213 54.9036) scale(42.9597 42.9597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA5B2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_308_7963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.6382 -5.69925) scale(65.7236 66.3875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927793,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_308_7963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.617 -21.3826) scale(65.4405)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_308_7963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9105 13.2523) scale(12.3266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5C3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7A90AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#556476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#37404C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1F252B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0E1114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopContributor);
export default __webpack_public_path__ + "static/media/top-contributor.714d3b2a37fa6ed101ed57eedda9b8dd.svg";
export { ForwardRef as ReactComponent };